/*
  dev-stat-anim — plays the Figma motion timelines of the stat-grid cards
  (sections/dev-stat-grid.liquid + blocks/dev-stat-card.liquid).

  The keyframes themselves are CSS, in dev-stat-card's stylesheet, and only
  apply once a card carries `data-anim-state`. This file decides WHEN:

    - mode comes from the section: data-dev-anim="once" | "loop" | "off".
      Figma marks the BOGO cohort (8793:17205) `loopMode: once` and every
      other stat-card cohort `loopMode: loop`.
    - each card starts when it scrolls into view (IntersectionObserver, 35%
      visible), so the mobile carousel's off-screen cards wait for their swipe.
    - loop: every `data-anim-period` ms (the Figma cohort length — 3000, or
      2327.662 on Sleep) all of the card's animations jump back to 0 together,
      which is what a looping Figma timeline does. Off screen it parks at 0.
    - prefers-reduced-motion: nothing is stamped, so the end state shows.
*/
(function () {
  if (window.devStatAnim) {
    window.devStatAnim.scan();
    return;
  }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var io = null;

  function animations(card) {
    return typeof card.getAnimations === 'function' ? card.getAnimations({ subtree: true }) : [];
  }

  function rewind(card) {
    var list = animations(card);
    for (var i = 0; i < list.length; i++) list[i].currentTime = 0;
  }

  function play(card) {
    if (card.getAttribute('data-anim-state') === 'play') return;
    if (card._dsaMode === 'once' && card._dsaPlayed) return;
    rewind(card);
    card.setAttribute('data-anim-state', 'play');
    card._dsaPlayed = true;
    if (card._dsaMode === 'loop') {
      var period = parseFloat(card.getAttribute('data-anim-period')) || 3000;
      card._dsaTimer = window.setInterval(function () {
        rewind(card);
      }, period);
    }
  }

  function park(card) {
    if (card._dsaMode !== 'loop') return;
    window.clearInterval(card._dsaTimer);
    card.setAttribute('data-anim-state', 'ready');
    rewind(card);
  }

  function observer() {
    if (io) return io;
    io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var e = entries[i];
          if (e.isIntersecting && e.intersectionRatio >= 0.35) play(e.target);
          else if (!e.isIntersecting) park(e.target);
        }
      },
      { threshold: [0, 0.35] }
    );
    return io;
  }

  function setup(section) {
    var mode = section.getAttribute('data-dev-anim');
    if (mode !== 'once' && mode !== 'loop') return;
    if (reduce.matches || typeof IntersectionObserver === 'undefined') return;

    var cards = section.querySelectorAll('.dev-stat-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card._dsaMode) continue;
      card._dsaMode = mode;
      card.setAttribute('data-anim-state', 'ready');
      observer().observe(card);
    }
  }

  function scan(root) {
    var sections = (root || document).querySelectorAll('[data-dev-anim]');
    for (var i = 0; i < sections.length; i++) setup(sections[i]);
  }

  function teardown(root) {
    var cards = root.querySelectorAll('.dev-stat-card[data-anim-state]');
    for (var i = 0; i < cards.length; i++) {
      window.clearInterval(cards[i]._dsaTimer);
      if (io) io.unobserve(cards[i]);
    }
  }

  window.devStatAnim = { scan: function () { scan(document); } };

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    teardown(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }
})();
